export default __webpack_public_path__ + "static/media/uber.50e439d7.svg";